var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./content/form.html"] = require( "./content/form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/setup.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./content/form.html", false, "views/setup.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\r\n\r\n<div>\r\n    <div class=\"box pull-center\">\r\n        <div class=\"aside-box\">\r\n            <div class=\"logo\">\r\n                <span class=\"logo-icon infodatek-icon infodatek-icon-";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "product")), env.opts.autoescape);
output += "\"></span>\r\n                <span class=\"logo-text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"product"), env.opts.autoescape);
output += "</span>\r\n            </div>\r\n            <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Installation"), env.opts.autoescape);
output += "</h3>\r\n            <ol class=\"step-list\">\r\n                ";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Menu");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("stepname", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n                    <li data-setup-step=\"set:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") < runtime.contextOrFrameLookup(context, frame, "currentStep")?"clickable":""), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == runtime.contextOrFrameLookup(context, frame, "currentStep")?" active":""), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") < runtime.contextOrFrameLookup(context, frame, "currentStep")?" done":""), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += "</li>\r\n                ";
;
}
}
frame = frame.pop();
output += "\r\n            </ol>\r\n        </div>\r\n        <div class=\"steps\">\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "loading")) {
output += "\r\n                <div class=\"spinner pull-center\"></div>\r\n            </div>\r\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "currentStep") != 0) {
output += "\r\n            <h2>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Title"), env.opts.autoescape);
output += "</h2>\r\n            <div class=\"error-box\" style=\"display:none;\"></div>\r\n            <div class=\"step\" data-step=\"0\">\r\n                <div class=\"v-center\">\r\n                    <div>\r\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"IsLast") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"LicenseInfo")) {
output += "\r\n                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Text")), env.opts.autoescape);
output += "\r\n                        ";
;
}
else {
output += "\r\n                            <form data-step=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentStep"), env.opts.autoescape);
output += "\">\r\n                                <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Text"), env.opts.autoescape);
output += "</h3>\r\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"IsLoading")) {
output += "\r\n                                    <div class=\"spinner pull-center\"></div>\r\n                                ";
;
}
output += "\r\n                                ";
frame = frame.push();
var t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Columns");
if(t_10) {var t_8;
if(runtime.isArray(t_10)) {
var t_9 = t_10.length;
for(t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8][0]
frame.set("key", t_10[t_8][0]);
var t_12 = t_10[t_8][1]
frame.set("col", t_10[t_8][1]);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\r\n                                    <div class=\"col\">\r\n                                        ";
if(runtime.memberLookup((t_12),"Name") == "Password") {
output += "\r\n                                            <ul class=\"password-requires\">\r\n                                                <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordText"), env.opts.autoescape);
output += "</span>\r\n                                                <li data-regex=\".{8,}\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq1"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[a-z]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq2"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[A-Z]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq3"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[\\d]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq4"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[$@$!%*?&amp;]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq5"), env.opts.autoescape);
output += "</li>\r\n                                            </ul>\r\n                                        ";
;
}
output += "\r\n                                        <label class=\"form-field\">\r\n                                            <div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Title"), env.opts.autoescape);
output += "</div>\r\n                                            <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_12),"Type") == " money"?" money":""), env.opts.autoescape);
output += "\"=\"Money\"}}\"\">\r\n                                                ";
output += runtime.suppressValue((lineno = 49, colno = 70, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_12,runtime.memberLookup((t_12),"Type"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((t_12),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n                                            </div>\r\n                                        </label>\r\n                                    </div>\r\n                                ";
;
}
} else {
t_8 = -1;
var t_9 = runtime.keys(t_10).length;
for(var t_13 in t_10) {
t_8++;
var t_14 = t_10[t_13];
frame.set("key", t_13);
frame.set("col", t_14);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\r\n                                    <div class=\"col\">\r\n                                        ";
if(runtime.memberLookup((t_14),"Name") == "Password") {
output += "\r\n                                            <ul class=\"password-requires\">\r\n                                                <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordText"), env.opts.autoescape);
output += "</span>\r\n                                                <li data-regex=\".{8,}\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq1"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[a-z]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq2"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[A-Z]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq3"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[\\d]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq4"), env.opts.autoescape);
output += "</li>\r\n                                                <li data-regex=\"[$@$!%*?&amp;]\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"InstallPasswordReq5"), env.opts.autoescape);
output += "</li>\r\n                                            </ul>\r\n                                        ";
;
}
output += "\r\n                                        <label class=\"form-field\">\r\n                                            <div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((t_14),"Title"), env.opts.autoescape);
output += "</div>\r\n                                            <div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_14),"Type") == " money"?" money":""), env.opts.autoescape);
output += "\"=\"Money\"}}\"\">\r\n                                                ";
output += runtime.suppressValue((lineno = 49, colno = 70, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_14,runtime.memberLookup((t_14),"Type"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((t_14),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n                                            </div>\r\n                                        </label>\r\n                                    </div>\r\n                                ";
;
}
}
}
frame = frame.pop();
output += "\r\n                            </form>\r\n                        ";
;
}
output += "\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"actions\">\r\n                <button data-setup-step=\"rel:-1\" class=\"button button-menu pull-left clickable\" ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "currentStep") == 0?"disabled":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Previous"), env.opts.autoescape);
output += "</button>\r\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"LicenseInfo") && runtime.contextOrFrameLookup(context, frame, "showExpiredLicenseScreen")) {
output += "\r\n                    <button data-setup-step=\"set:4\" class=\"button button-default pull-right clickable\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Done"), env.opts.autoescape);
output += "</button>\r\n                ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"LicenseInfo")) {
output += "\r\n                    <button data-setup-step=\"rel:1\" class=\"button button-default pull-right clickable\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Next"), env.opts.autoescape);
output += "</button>\r\n                ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"IsLast")) {
output += "\r\n                    <button data-setup-step=\"rel:1\" class=\"button button-default pull-right clickable\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Done"), env.opts.autoescape);
output += "</button>\r\n                ";
;
}
else {
output += "\r\n                    <button data-setup-step=\"rel:1\" disabled=\"disabled\" class=\"button button-default pull-right\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"Next"), env.opts.autoescape);
output += "</button>\r\n                ";
;
}
;
}
;
}
output += "\r\n            </div>\r\n        ";
;
}
else {
output += "\r\n            <h2>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Title"), env.opts.autoescape);
output += "</h2>\r\n            <form class=\"setup-languages\" data-step=\"0\">\r\n                <input type=\"hidden\" name=\"LangID\">\r\n                ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "step")),"Columns")),"LangID")),"Dropdown")),"Items");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("lang", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\r\n                    <div class=\"language\">\r\n                        <div class=\"flag-block\" data-select-language=\"";
output += runtime.suppressValue(runtime.memberLookup((t_18),"Value"), env.opts.autoescape);
output += "\">\r\n                            <img src=\"/App_Themes/images/flags/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"Value"), env.opts.autoescape);
output += ".svg\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_18),"Key"), env.opts.autoescape);
output += "\">\r\n                            <div class=\"language-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"Text"), env.opts.autoescape);
output += "</div>\r\n                        </div>\r\n                    </div>\r\n                ";
;
}
}
frame = frame.pop();
output += "\r\n            </form>\r\n        ";
;
}
;
}
output += "\r\n    </div>\r\n</div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/setup.html"] , dependencies)